/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { medicosConfiguracionControllerCambiarPassword } from '../fn/medicos-configuracion/medicos-configuracion-controller-cambiar-password';
import { MedicosConfiguracionControllerCambiarPassword$Params } from '../fn/medicos-configuracion/medicos-configuracion-controller-cambiar-password';

@Injectable({ providedIn: 'root' })
export class MedicosConfiguracionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicosConfiguracionControllerCambiarPassword()` */
  static readonly MedicosConfiguracionControllerCambiarPasswordPath = '/api/medicos-configuracion/cambiar-password';

  /**
   * Cambiar contraseña del médico.
   *
   * Cambia la contraseña del médico autenticado.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicosConfiguracionControllerCambiarPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosConfiguracionControllerCambiarPassword$Response(params: MedicosConfiguracionControllerCambiarPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return medicosConfiguracionControllerCambiarPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambiar contraseña del médico.
   *
   * Cambia la contraseña del médico autenticado.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicosConfiguracionControllerCambiarPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  medicosConfiguracionControllerCambiarPassword(params: MedicosConfiguracionControllerCambiarPassword$Params, context?: HttpContext): Observable<void> {
    return this.medicosConfiguracionControllerCambiarPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
